/**
 * Deleo delivery tracking status codes
 * These are the status codes returned from the Deleo API
 */
export enum DeliveryTrackingStatus {
  Delivered = 'D06',
  CustomsCleared = 'I04',
  InCustoms = 'I03',
  ArrivedDestination = 'I02',
  Departed = 'I01',
  InvoiceIssued = 'I00',
}

export const DELIVERED_STATUS = DeliveryTrackingStatus.Delivered;

